<div class="padding-b-70">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16 line-25">
         <li>
            <div class="">
               <div class="brand-head flex hr-space-between align-top margin-b-20">
                  <div class="">
                     <div class="flex margin-b-15 wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="50ms">
                        <div class="icon brand-icon wid-100">
                           <img src="assets/images/one.png" alt="">
                        </div>
                        <div class="icon brand-icon wid-100 margin-l-20">
                           <img src="assets/images/one-champ.png" alt="">
                        </div>
                        <!-- <div class="icon brand-icon wid-100 margin-l-20">
                           <img src="assets/images/one-sports.png" alt="">
                        </div> -->
                     </div>
                     <div class="font-15 light-color proximaNovaSb wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="100ms">Group ONE Holdings
                     </div>
                  </div>
                  <div class="font-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="100ms">
                     <a href="https://groupone-holdings.com" target="_blank" class="highlight-color proximaNovaSb">
                        https://groupone-holdings.com
                     </a>
                  </div>
               </div>
               <div class="">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Founded in 2011, Group ONE Holdings (GOH) is the parent company for ONE Championship.
                      ONE Championship is one of the most viewed sports media properties in Asia with over 1.5
                     billion organic video views per month (ranking ONE in top 5 global sports properties according to
                     Neilsen Sports).
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Headquartered in Singapore, ONE hosts the largest sports entertainment events across Asia,
                     featuring many of the world’s best martial artists. The company offers ONE
                     content broadcast across various platforms and devices, such as free-to-air TV, paid TV, digital,
                     social, TV, computers, and mobile. In 2021, the company partnered with MGM to launch “The
                     Apprentice: ONE Championship Edition.”
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     ONE ranks among the largest sports leagues in the world on the basis of audience scale and
                     viewership metrics. ONE has more than 50 million digitally and socially engaged fans, increasing by
                     high double digits each year, billions of organic digital interactions, hundreds of millions of
                     terrestrial viewers spread across 150 countries, and mostly millennium and gen Z audience.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Mission Holdings is the largest shareholder. Sequoia Capital, Temasek, ICONIQ, Qatar Investment Authority and Guggenheim are also invested in ONE. Saurabh Mittal serves as the Vice-Chairman of the board at Group ONE Holdings (GOH).
                  </div>
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/Chatri_Sityodtong.jpeg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Chatri Sityodtong</div>
                  <div class="font-14 light-color proximaNovaSb">Chairman, CEO & Founder</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Founder, Chairman and CEO of ONE Championship, Asia’s largest global sports media property in history
                  with a broadcast to 150+ countries around the world.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Sityodtong is a self-made entrepreneur and lifelong martial artist from Thailand. His rags-to-riches
                  life story has inspired millions around the world on BBC, CNN, Bloomberg, CNBC, and other major media.
                  He is also the star of the latest edition of The Apprentice, the award-winning, global reality TV
                  series. Most recently, Sityodtong was named “Asia’s King of Martial Arts” by the Financial Times and
                  was ranked the “2nd Most Powerful Person in Sports in Asia” by FOX Sports. Sityodtong was also
                  selected as one of “Asia’s Top 100 Business Leaders” by Business Insider.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Inducted into the Black Belt Hall of Fame in 2019, Sityodtong has over 35 years of martial arts
                  experience as a student, a fighter, a teacher, and a coach. Sityodtong is a certified senior Muay Thai
                  instructor under the legendary Kru Yodtong Senanan of the world-renowned Sityodtong Gym in Thailand.
                  He also holds a Purple Belt in Brazilian Jiu-Jitsu under Master Renzo Gracie.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Chatri Sityodtong holds an MBA from Harvard Business School and a BA from Tufts University.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/Hua_Fung_Teh.jpeg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Hua Fung Teh</div>
                  <div class="font-14 light-color proximaNovaSb">President</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Hua Fung Teh is the Group President of ONE Championship. Together with Chairman and CEO Chatri
                  Sityodtong, Teh leads the company’s management team with a focus on group strategy, international
                  expansion, global strategic partnerships, and capital markets.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to ONE, Teh was a Principal at global private equity firm TPG Capital (TPG). As a senior member
                  of the Southeast Asia investment team, he was responsible for the origination, execution, and
                  portfolio management of growth and late-stage investment deals in Southeast Asia. He also served on
                  TPG’s China and U.S. teams. Before TPG, Teh was an aviator with the Republic of Singapore Air Force
                  (RSAF) and held leadership positions both at the RSAF and at Singapore’s Ministry of Trade and
                  Industry, where he served as the ministry’s Formula One (F1) Project Team Leader. In that role, he
                  helped secure the F1 Grand Prix hosting rights for Singapore and coordinated efforts between
                  government agencies and private sector parties to execute the first night race in F1 history in 2008.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Teh holds an MBA from Harvard Business School and an MEng and BS in Electrical Engineering from the
                  Massachusetts Institute of Technology (MIT), where he was a member of the men’s varsity basketball
                  team. A taekwondo black-belt holder, he also sits on the Global Steering Committee of the Milken
                  Institute Young Leaders Circle and is a member of The Forum of Young Global Leaders at the World
                  Economic Forum.
               </div>
            </div>
         </li>
      </ul>
   </div>
</div>
